import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/risks/mentalHealthReview";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	mentalHealthReview: {
		id: "form.mental_health_review",
		defaultMessage: "Pszichológiai felmérés"
	},
	description: {
		id: "form.mental_health_review.description",
		defaultMessage: "Szöveges összefoglaló"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "mentalHealthReview",
	value: {
		title: messages.mentalHealthReview,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true,
		defaults: [
			{
				path: ["description"],
				query: {
					interpretation: {
						vocab: "htx",
						code: "mental_health_review"
					}
				}
			}
		]
	}
};
